<form
  name="form"
  fxLayout="column"
  autocomplete="off"
  class="field-dialog__content__scroll tab-groups p-24"
  [ngClass]="{ 'with-disclaimer': isViewMode }"
  fusePerfectScrollbar
>
  <div class="field-outline-form">
    <div class="tab-groups__search-bar" fxLayout="row" fxLayoutAlign="space-between stretch" fxLayoutGap="12px">
      <mat-form-field appearance="outline" fxFlex>
        <mat-label>
          {{ 'USERS.DIALOG.TAB_GROUPS.LINKED.SEARCH' | translate }}
        </mat-label>

        <mat-icon matPrefix color="primary">search</mat-icon>

        <input matInput [formControl]="searchInput" (keydown)="$event.stopImmediatePropagation()" />

        <mat-hint>
          {{ 'USERS.DIALOG.TAB_GROUPS.SEARCH_SUGGESTION' | translate }}
        </mat-hint>
      </mat-form-field>

      <button
        *ngIf="!isViewMode"
        (click)="linkGroups()"
        class="tab-groups__search-bar__button"
        mat-raised-button
        color="primary"
        fxFlex="25"
      >
        {{ 'USERS.DIALOG.TAB_GROUPS.LINKED.ADD' | translate }}
      </button>
    </div>
  </div>

  <linked-groups
    *ngIf="linkedGroups"
    [linkedGroups]="linkedGroups"
    [searchInput]="searchInput"
    [isViewMode]="isViewMode"
  ></linked-groups>
</form>
